<template>
  <VSlideGroup
    max="1"
    :show-arrows="true"
    class="custom"
  >
    <VSlideItem
      v-for="(logo, i) in items"
      :key="i"
    >
      <div class="logotype">
        <img
          :src="require(`../../assets/img/landing/logotypes/${logo}`)"
          alt=""
          class="img-container"
        >
        <img
          :src="require(`../../assets/img/landing/logotypes/${logo.replace('.', gsString)}`)"
          alt=""
          class="gs"
        >
        <img :src="require(`../../assets/img/landing/logotypes/${logo}`)" alt="" class="normal">
      </div>
    </VSlideItem>
  </VSlideGroup>
</template>

<script>
export default {
  name: 'LogotypesSlider',
  props: {
    items: {
      type: Array,
      default: function items() {
        return [];
      },
    },
    nogs: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    gsString() {
      return this.nogs ? '.' : '-gs.';
    },
  },
};
</script>

<style lang="scss">
.custom .v-slide-group__content {
  justify-content: space-between;
}
</style>

<style scoped lang="scss">
.logotypes {
  min-height: 148px;
}
.logotype {
  position: relative;
  display: flex;
  padding: 2rem;
  justify-content: center;
  align-items: center;
  padding: $spacer * 3;
  box-sizing: border-box;

  img {
    width: auto;
    max-width: 100%;
    height: auto;
    transition: opacity 300ms ease;

    &.img-container {
      opacity: 0;
    }

    &.gs {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      opacity: 1;
    }

    &.normal {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      opacity: 0;
    }
  }

  &:hover {
    .gs {
      opacity: 0;
    }
    .normal {
      opacity: 1;
    }
  }
}
@media #{map-get($display-breakpoints, 'md-and-up')} {
  .logotypes {
    min-height: initial;
  }
  .logotype {
    width: auto;
    max-height: 55px;
    padding: 0;

    img {
      max-height: 55px;
    }

  }
}
</style>
